import {
  FETCH_NAV_HEADER_PENDING,
  FETCH_NAV_HEADER_REJECTED,
  FETCH_NAV_HEADER_FULFILLED
} from "../constants/navHeader";

const initialState = {
  currentStaff: {},
  pending: true,
  error: {},
};

export const navHeader = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NAV_HEADER_PENDING:
      return {
        ...state,
        pending: false,
        error: {},
        currentStaff: {}
      };

    case FETCH_NAV_HEADER_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.error,
      };

    case FETCH_NAV_HEADER_FULFILLED:
      return {
        ...state,
        pending: false,
        currentStaff: action.response,
        error: {}
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/navHeader.js